module.exports = __webpack_public_path__ + "img/app-icon.4a9b5154.png";